"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RsvpReminderData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
exports.RsvpReminderData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("rsvpReminder"),
    occurrence: UUID_1.UUID,
    user: UUID_1.UUID,
}).And((0, runtypes_1.Partial)({
    order: UUID_1.UUID,
})));
//# sourceMappingURL=RsvpReminderData.js.map